import React from "react";
import { Layout } from "antd";

import resources from "scripts/resources";

const { Footer } = Layout;

export default () => <Footer>{resources.copyright}</Footer>;
